import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";

export const HelpPage = () => {
  const { profileData }: any = useAppSelector((state) => state.ProfileState);
  const aboutUs = useAppSelector((state) => state.FooterDataState.aboutUs);

  return (
    <>
      <div
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: 400,
          color: "var(--main)",
          backgroundColor: "var(--white)",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content text-center">
            <img
              src="images/logo.svg"
              width="100"
              alt=""
              style={{
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "20%",
              }}
            />

            <div className="header mb-2">
              <div
                className="demo-title"
                style={{ fontSize: "18px", marginTop: "15px" }}
              >
                Help for your Order
              </div>
            </div>
            <div className="tf-login-form">
              <form className="">
                <div className="mb-3 mt-0">
                  <p>
                    <span className="address-text">
                      Hey{" "}
                      {profileData?.data?.first_name
                        ? profileData?.data?.first_name
                        : profileData?.data?.phone_number}
                      ! 😊 If you have any concerns please contact Phone No.
                      {"  "}
                    </span>
                    <span>{aboutUs?.data?.data?.contact_us?.phone_number}</span>{" "}
                  </p>
                </div>
                <div className="mb-3 mt-0">
                  <p>
                    <span className="address-text">Or you can mail to </span>
                    <span>{aboutUs?.data?.data?.contact_us?.email}</span>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
